import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/context/LanguageContext";
import VideoPlayer from "@/components/VideoPlayer";
import { videoSection } from "@/i18n/seoPages";

// Section vidéo complète (texte + lecteur), utilisée sur /pellicules/miroir.
export default function VideoSection({ dark = false, testId = "video-section" }) {
  const { lang } = useLanguage();
  const v = videoSection[lang];

  return (
    <section
      data-testid={testId}
      className={`py-20 sm:py-28 lg:py-40 ${dark ? "bg-slate-950 text-white" : "bg-white"}`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        {/* Texte */}
        <div className="order-2 lg:order-1">
          <div className={`text-xs tracking-[0.3em] uppercase font-display font-semibold ${dark ? "text-blue-400" : "text-blue-600"}`}>
            {v.eyebrow}
          </div>
          <h2
            data-testid={`${testId}-title`}
            className={`font-heading text-3xl lg:text-5xl font-normal tracking-tight leading-[1.2] mt-4 ${dark ? "text-white" : "text-slate-900"}`}
          >
            {v.title}
          </h2>
          <p
            data-testid={`${testId}-summary`}
            className={`mt-8 text-lg leading-relaxed ${dark ? "text-slate-300" : "text-slate-600"}`}
          >
            {v.summary}
          </p>
          <Link to="/contact" data-testid={`${testId}-cta`} className="block sm:inline-block">
            <Button className="w-full sm:w-auto mt-10 rounded-full bg-blue-600 hover:bg-blue-700 text-white h-auto min-h-14 px-6 py-3.5 text-base font-medium shadow-lg shadow-black/10 whitespace-normal text-center leading-snug">
              {v.cta}
              <ArrowRight className="ml-2 w-4 h-4 flex-shrink-0" />
            </Button>
          </Link>
        </div>

        {/* Lecteur vertical 9:16 */}
        <div className="order-1 lg:order-2 flex justify-center">
          <VideoPlayer testId={testId} withJsonLd className="w-full max-w-[340px] sm:max-w-[380px]" />
        </div>
      </div>
    </section>
  );
}
